<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import AlertListDetailSlide from '@/common/components/organisms/alertListDetail/AlertListDetailSlide.vue';
import { setup, type Props } from './overviewAlert.setup';

const props = defineProps<Props>();

const { isShowAlertDetail, alertCount, onClickAlert, type } = setup(props);
</script>

<template>
  <base-button
    type="icon"
    class="overview-alert-icon"
    @click="onClickAlert"
  >
    <ev-icon icon="icon-bell" />
    <span :class="['overview-alert-icon__count', { none: alertCount === 0 }]">
      {{ alertCount > 99 ? '99+' : alertCount }}
    </span>
  </base-button>
  <alert-list-detail-slide
    v-model:is-visible="isShowAlertDetail"
    :type="type"
    :alert-info="props.alertInfo"
  />
</template>

<style scoped lang="scss">
.overview-alert-icon {
  position: absolute;
  right: 12px;
  &__count {
    position: absolute;
    top: 100%;
    left: 100%;
    min-width: 16px;
    padding: 0 2px;
    margin: -12px 0 0 -12px;
    border-radius: 50%;
    background-color: var(--alert-count-item-critical-border);
    font-size: 10px;
    line-height: 14px;
    color: var(--color-d-gray-00);
    text-align: center;

    &.none {
      background-color: var(--alert-count-item-default-bg);
    }
  }
}
</style>
